import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.brandfolder(); // bulk management passed as collection due to routing
const url = () => `/api/v4/private/${type.toLowerCase()}s/${key}/csv_uploads?sort_by=created_at&order=desc`;

export const get = () => (
  fetchJSON(url())
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);
